import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f845096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container is-fluid" }
const _hoisted_2 = { class: "card mb-5" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-header-title" }
const _hoisted_5 = { class: "columns is-flex-grow-1" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "column is-narrow has-text-right" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" in project ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" View entities in this project ")
const _hoisted_12 = { class: "card-content" }
const _hoisted_13 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Created by ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title is-4" }, "Details", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "notification is-warning"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title is-4" }, "Related elements", -1))
const _hoisted_19 = { class: "notification is-warning" }
const _hoisted_20 = {
  key: 1,
  class: "notification is-danger"
}
const _hoisted_21 = {
  key: 2,
  class: "notification is-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WorkerRunSummary = _resolveComponent("WorkerRunSummary")!
  const _component_ElementList = _resolveComponent("ElementList")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.entity)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("header", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      class: "tag mr-2",
                      style: _normalizeStyle(_ctx.entityStyle(_ctx.entity.type))
                    }, _toDisplayString(_ctx.entity.type.name), 5),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.entity.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_router_link, {
                      to: { name: 'navigation', params: { corpusId: _ctx.entity.corpus.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.entity.corpus.name), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _hoisted_10,
                    _createVNode(_component_router_link, {
                      to: { name: 'corpus-entities', params: { corpusId: _ctx.entity.corpus.id } }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.entity.worker_run)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                    _hoisted_14,
                    (_ctx.entity.worker_run)
                      ? (_openBlock(), _createBlock(_component_WorkerRunSummary, {
                          key: 0,
                          "worker-run-details": _ctx.entity.worker_run,
                          multiline: ""
                        }, null, 8, ["worker-run-details"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_15,
              (_ctx.hasMetas)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entity.metas, (value, key) => {
                      return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(key) + " : " + _toDisplayString(value), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, " No details available. "))
            ])
          ]),
          _hoisted_18,
          _createVNode(_component_Paginator, {
            response: _ctx.elements,
            singular: "element",
            plural: "elements"
          }, {
            default: _withCtx(({ results }) => [
              _createVNode(_component_ElementList, { elements: results }, null, 8, ["elements"])
            ]),
            "no-results": _withCtx(() => [
              _createElementVNode("div", _hoisted_19, "No elements linked to " + _toDisplayString(_ctx.entity.name), 1)
            ]),
            _: 1
          }, 8, ["response"])
        ], 64))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.error), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, "Loading..."))
  ]))
}